export var compKey = 'toggle-list';
//# sourceMappingURL=key.js.map